import { useCallback } from 'react';
import { useField } from 'formik';

import VirtualPackSelect from 'components/VirtualPackSelect';
import type { IVirtualPackField } from './types';

export default function ProductSelectField({
  name,
  disabled,
  onChange,
  textFieldProps,
}: IVirtualPackField) {
  const [{ value }, metaId, { setValue, setTouched }] = useField(name);

  const hasError = Boolean(metaId.touched && metaId.error);
  const helperText = hasError ? metaId.error : '';

  const handleOnBlur = useCallback(async () => {
    if (!metaId.touched) await setTouched(true, false);
  }, [setTouched, metaId]);

  const handleChange = useCallback(
    async (value) => {
      const newVal = value ? value.packagedItemReference : '';

      await setValue(newVal, true);
      onChange(newVal);
    },
    [onChange, setValue],
  );

  return (
    <VirtualPackSelect
      disabled={disabled}
      selectedProductReference={value}
      onChange={handleChange}
      textFieldProps={{
        name: name,
        error: hasError,
        helperText: helperText,
        onBlur: handleOnBlur,
        ...textFieldProps,
      }}
    />
  );
}
